import { ThemeContext } from 'styled-components';
import { useContext } from 'react';
import { PropTypes } from 'prop-types';
import icons from '~/constants/icons';
import RenderWithProps from '~/utils/renderWithProps';

function useTheme() {
  return useContext(ThemeContext);
}

export default function Icon({ name, size, color, className, text, ...rest }) {
  const theme = useTheme();

  return RenderWithProps(icons[name], {
    size,
    color: theme[color],
    className,
    text,
    ...rest,
  });
}

Icon.propTypes = {
  name: PropTypes.string,
  size: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  text: PropTypes.string,
};

Icon.defaultProps = {
  name: 'avatar',
  size: 15,
  color: 'dark',
  text: '',
};
